(() => {
  'use strict';
  const priorities = {
    'card-sleeves': 'shining-soul-tcg-riftbound-league-of-legends-card-sleeves-red',
    sleeves: 'shining-soul-tcg-riftbound-league-of-legends-card-sleeves-red',
    binders: 'shining-soul-tcg-riftbound-league-of-legends-binder-red',
    'deck-boxes': 'shining-soul-tcg-riftbound-league-of-legends-deck-box-red'
  };
  function targetFor(url, kind) {
    const params = url.searchParams;
    const sort = params.get('sort_by');
    if (sort && sort !== (kind === 'search' ? 'relevance' : 'manual')) return '';
    if (kind === 'collection') return priorities[url.pathname.split('/').filter(Boolean).pop()] || '';
    if (params.get('format') !== 'accessory' || params.get('origin') === 'fan-made' || params.get('base_q')) return '';
    return priorities[params.get('category')] || '';
  }
  function promote(items, target) {
    const index = items.findIndex(item => item.handle === target);
    if (index <= 0) return items;
    return [items[index], ...items.slice(0, index), ...items.slice(index + 1)];
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { targetFor, promote };
    return;
  }
  async function init() {
    const meta = document.querySelector('[data-sc-category-priority]');
    if (!meta || meta.dataset.started) return;
    meta.dataset.started = 'true';
    const url = new URL(window.location.href);
    const target = targetFor(url, meta.dataset.kind);
    if (!target) return;
    const selector = meta.dataset.kind === 'search' ? '.tcg-product-grid--search' : '.tcg-product-grid--collection';
    const grid = document.querySelector(selector);
    if (!grid) return;
    const page = Number(meta.dataset.page), pages = Number(meta.dataset.pages);
    const total = Number(meta.dataset.total), size = Number(meta.dataset.size);
    if (!page || !pages || !size || !total) return;
    const readCards = root => Array.from(root.children).map(node => ({
      handle: node.querySelector('[data-product-handle]')?.dataset.productHandle,
      node
    }));
    const current = readCards(grid);
    if (current.some(item => !item.handle)) return;
    // A one-page category needs no network round trip.
    if (pages === 1) {
      grid.replaceChildren(...promote(current, target).map(item => item.node));
      meta.dataset.state = current.some(item => item.handle === target) ? 'applied' : 'not-matched';
      return;
    }
    // Read the same filtered pages before moving an item across a page boundary.
    // This keeps every other item in its original order without losing the last
    // card on page 1 or repeating the promoted card on a later page.
    const batches = new Array(pages);
    batches[page - 1] = current;
    const queue = Array.from({length: pages}, (_, i) => i + 1).filter(n => n !== page);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    grid.setAttribute('aria-busy', 'true');
    const makeCardContext = node => {
      if (meta.dataset.kind !== 'search') return;
      node.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const productUrl = new URL(link.getAttribute('href'), url.origin);
        productUrl.searchParams.set('sc_accessory', '1');
        for (const key of ['game', 'category', 'origin']) {
          if (url.searchParams.get(key)) productUrl.searchParams.set('sc_' + key, url.searchParams.get(key));
        }
        link.href = productUrl.pathname + productUrl.search;
      });
    };
    try {
      const worker = async () => {
        while (queue.length) {
          const number = queue.shift();
          const otherUrl = new URL(url);
          otherUrl.searchParams.set('page', String(number));
          otherUrl.hash = '';
          const response = await fetch(otherUrl.href, {credentials: 'same-origin', signal: controller.signal});
          if (!response.ok) throw new Error('Category page unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const otherMeta = parsed.querySelector('[data-sc-category-priority]');
          const otherGrid = parsed.querySelector(selector);
          if (!otherMeta || !otherGrid || Number(otherMeta.dataset.total) !== total || Number(otherMeta.dataset.size) !== size || Number(otherMeta.dataset.page) !== number) throw new Error('Category changed while loading');
          batches[number - 1] = readCards(otherGrid);
        }
      };
      await Promise.all(Array.from({length: Math.min(3, queue.length)}, worker));
      const all = batches.flat();
      if (all.length !== total || all.some(item => !item.handle) || new Set(all.map(item => item.handle)).size !== total) throw new Error('Incomplete category');
      const ordered = promote(all, target);
      const visible = ordered.slice((page - 1) * size, page * size);
      visible.forEach(item => makeCardContext(item.node));
      grid.replaceChildren(...visible.map(item => item.node));
      meta.dataset.state = all.some(item => item.handle === target) ? 'applied' : 'not-matched';
    } catch (_) {
      // Preserve Shopify's original usable results if loading fails.
      controller.abort();
      meta.dataset.state = 'fallback';
    } finally {
      window.clearTimeout(timeout);
      grid.removeAttribute('aria-busy');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
